import { render, staticRenderFns } from "./addNewItems.vue?vue&type=template&id=91b9aa40&scoped=true&"
import script from "./addNewItems.vue?vue&type=script&lang=js&"
export * from "./addNewItems.vue?vue&type=script&lang=js&"
import style0 from "./addNewItems.vue?vue&type=style&index=0&id=91b9aa40&scoped=true&lang=css&"
import style1 from "./addNewItems.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b9aa40",
  null
  
)

export default component.exports